export const parseJSON = <T>(json: string, defaultValue: T): T => {
    try {
        return JSON.parse(json);
    } catch (error) {
        return defaultValue;
    }
};
